export const COMPANY_CONTACT = {
  main: {
    email: "contact@polymath.com",
    phone: "+1 (212) 555-0123",
    address: "100 Wall Street, New York, NY 10005"
  },
  departments: {
    privacy: "privacy@polymath.com",
    legal: "legal@polymath.com",
    support: "support@polymath.com"
  },
  offices: [
    {
      city: "New York",
      address: "100 Wall Street, New York, NY 10005",
      phone: "+1 (212) 555-0123",
      email: "contact@polymath.com"
    },
    {
      city: "London",
      address: "30 St Mary Axe, London EC3A 8BF",
      phone: "+44 20 7123 4567",
      email: "contact@polymath.com"
    },
    {
      city: "Singapore",
      address: "1 Raffles Place, Singapore 048616",
      phone: "+65 6789 0123",
      email: "contact@polymath.com"
    }
  ]
} 